import { useRef, useState } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    useIonAlert,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
    IonTextarea,
    IonCheckbox,
    IonIcon,
    IonSpinner,
    IonSelect,
    IonSelectOption
} from '@ionic/react';
import { checkmark, chevronBack, printOutline } from 'ionicons/icons';
//import "./DocumentTemplateEditor.css";

import { Editor } from '@tinymce/tinymce-react';
import { useHistory, useParams } from 'react-router';
import { addDocumentTemplate, deleteDocumentTemplate, getDocumentTemplate, setDocumentTemplate } from '../firebase/documentTemplates';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer';
import { cordovaWarn } from '@awesome-cordova-plugins/core/decorators/common';
import { Capacitor } from '@capacitor/core';


const DocumentTemplateEditor: React.FC = () => {
    const editorRef = useRef(null);

    const [busy, setBusy] = useState(false);

    const params: any = useParams();
    const history = useHistory();
    var initData: any = {};
    var isNew = true;
    if (params.id !== undefined && params.id !== '0') {
        isNew = false;
        initData = getDocumentTemplate(params.id);
        if (initData === undefined) {
            initData = {};
        }
    }

    const [topic, setTopic] = useState(initData.topic ?? '');
    const [application, setApplication] = useState(initData.application ?? []);

    const [presentAlert] = useIonAlert();

    const topicRef = useRef<HTMLIonInputElement>(null);
    const defaultRef = useRef<HTMLIonCheckboxElement>(null);
    const senderRef = useRef<HTMLIonInputElement>(null);
    const textRef = useRef<HTMLIonTextareaElement>(null);



    async function confirm() {
        if (editorRef.current) {
            //@ts-ignore
            const text = editorRef.current.getContent();
            var data = { text: text, topic: topic, application: application }
            setBusy(true);
            if (isNew) {
                if (await addDocumentTemplate(data)) {
                    history.goBack();
                }
            } else {
                if (await setDocumentTemplate(data, initData.id)) {
                    history.goBack();
                }
            }
            setBusy(false);
        }





    }



    async function remove() {
        presentAlert({
            header: 'Usuwanie!',
            buttons: [
                {
                    text: 'Anuluj',
                    role: 'cancel'
                },
                {
                    text: 'Usuń',
                    role: 'confirm',
                },
            ],
            onDidDismiss: async (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    setBusy(true);
                    if (await deleteDocumentTemplate(initData.id)) {
                        history.goBack();
                    }
                    setBusy(false);
                }
            },
        })

    }

    function cancel() {
        history.goBack();
    }


    function print() {
        if (editorRef.current) {
            if (Capacitor.isNativePlatform()) {
                //var text = editorRef.current.getContent();
                //text = text.replace("<!-- pagebreak -->", '<div style="page-break-before: always"></div>');

                //@ts-ignore

                var text = editorRef.current.getDoc();
                text = new XMLSerializer().serializeToString(text);

                Printer.print(text, {
                    name: topic, margin: {
                        top: "10",
                        left: "55",
                        right: "15",
                        bottom: "10"
                    }
                });

            } else {
                //@ts-ignore
                editorRef.current.contentWindow.print();
            }
        }
    }


    var applicationList = [{ id: 1, name: "klient" }];

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{isNew ? "Nowy szablonu" : "Edycja szablonu " + initData.topic}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => print()}><IonIcon icon={printOutline} /></IonButton>
                        <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonItem>
                    <IonLabel position="fixed">Nazwa</IonLabel>
                    <IonInput placeholder="Nazwa" ref={topicRef} value={topic} onIonChange={(e) => { setTopic(e.detail.value) }} ></IonInput>
                    {!isNew && topic === "" ? <IonButton slot="end" color="danger" onClick={() => remove()}>usuń</IonButton> : ""}
                </IonItem>
                <IonItem>
                    <IonLabel>zastosowanie</IonLabel>
                    <IonSelect style={{ maxWidth: "70%" }} slot="end" interface="popover" onIonChange={(e) => setApplication(e.detail.value)} value={application} placeholder="zastosowanie" multiple={true}>
                        {applicationList.map(item => {
                            return <IonSelectOption key={item.id} value={item.id}>{item.name}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <div hidden={!busy} style={{
                    textAlign: "center",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    top: "50%",
                    transform: "translateY(-50%)"
                }}><IonSpinner></IonSpinner></div>
            </IonHeader>

            <IonContent className="ion-padding">



                <Editor
                    tinymceScriptSrc={'https://egabinet.wiq.pl/app/tinymce/tinymce.min.js'}
                    //apiKey='wy7dxy8wo21ot818w8cectp6u6opa4em2m7g21e9oog3had8'

                    //@ts-ignore
                    onInit={(evt, editor) => editorRef.current = editor}

                    initialValue={initData.text}
                    init={{
                        height: "100%",
                        width: "100%",
                        language_url: 'https://egabinet.wiq.pl/app/tinymce/langs/pl.js',
                        language: 'pl',
                        menubar: true,
                        plugins: 'importcss searchreplace directionality ' +
                            'code visualblocks visualchars image ' +
                            'table charmap pagebreak nonbreaking insertdatetime advlist lists wordcount ' +
                            'help charmap quickbars emoticons',

                        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | ' +
                            'outdent indent |  numlist bullist | forecolor backcolor removeformat | ' +
                            'pagebreak | charmap emoticons |  | ' +
                            'image',
                        content_style: `
                            body {
                                background: #fff;
                            }
                  
                            @media (min-width: 620px) {
                                html {
                                    background: #eceef4;
                                    min-height: 100%;
                                    padding: 0 .5rem
                                 }
                  
                                body {
                                    background-color: #fff;
                                    //box-shadow: 0 0 4px rgba(0, 0, 0, .15);
                                    //box-sizing: border-box;
                                    margin: 1rem auto 0;
                                    max-width: 620px;
                                    min-height: calc(100vh - 1rem);
                                    padding: 0rem 1rem 0rem 3rem
                                 }
                             }
                           `,

                    }}

                />
            </IonContent>

        </IonPage>
    );
};

export default DocumentTemplateEditor;


